// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询租金账单 GET /api/v1/finance/bills */
export async function FinanceBillControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceBillControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    "/api/v1/finance/bills",
    {
      method: "GET",
      params: {
        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        // pageSize has a default value: 10
        pageSize: "10",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 查询账单支付流水 GET /api/v1/finance/bills/${param0}/payment-records */
export async function FinanceBillControllerListPaymentRecordsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceBillControllerListPaymentRecordsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputPaymentRecordDtoArray>(
    `/api/v1/finance/bills/${param0}/payment-records`,
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}

/** 本商户清分规则列表 GET /api/v1/finance/clearing-rules */
export async function FinanceClearingRuleControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDtoArray>(
    "/api/v1/finance/clearing-rules",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建清分规则（草稿） POST /api/v1/finance/clearing-rules */
export async function FinanceClearingRuleControllerCreateV1(
  body: MyApi.CreateMerchantClearingRuleDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    "/api/v1/finance/clearing-rules",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 清分规则详情 GET /api/v1/finance/clearing-rules/${param0} */
export async function FinanceClearingRuleControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/finance/clearing-rules/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 归档清分规则 DELETE /api/v1/finance/clearing-rules/${param0} */
export async function FinanceClearingRuleControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/finance/clearing-rules/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新清分规则（仅草稿可改） PATCH /api/v1/finance/clearing-rules/${param0} */
export async function FinanceClearingRuleControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerUpdateV1Params,
  body: MyApi.UpdateMerchantClearingRuleDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/finance/clearing-rules/${param0}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除清分规则（草稿或已归档） POST /api/v1/finance/clearing-rules/${param0}/delete */
export async function FinanceClearingRuleControllerDeleteRuleV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerDeleteRuleV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/finance/clearing-rules/${param0}/delete`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 禁用清分规则（仅已生效规则） POST /api/v1/finance/clearing-rules/${param0}/disable */
export async function FinanceClearingRuleControllerDisableV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerDisableV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/finance/clearing-rules/${param0}/disable`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 启用清分规则（仅已生效规则） POST /api/v1/finance/clearing-rules/${param0}/enable */
export async function FinanceClearingRuleControllerEnableV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerEnableV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/finance/clearing-rules/${param0}/enable`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 撤销审批（待审批 → 草稿） POST /api/v1/finance/clearing-rules/${param0}/revoke */
export async function FinanceClearingRuleControllerRevokeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerRevokeV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/finance/clearing-rules/${param0}/revoke`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 提交审批（草稿 → 待审批） POST /api/v1/finance/clearing-rules/${param0}/submit */
export async function FinanceClearingRuleControllerSubmitV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceClearingRuleControllerSubmitV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputFinanceClearingRuleDto>(
    `/api/v1/finance/clearing-rules/${param0}/submit`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 分页查询押金账单 GET /api/v1/finance/deposits */
export async function FinanceDepositControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceDepositControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentDtoArray>(
    "/api/v1/finance/deposits",
    {
      method: "GET",
      params: {
        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        // pageSize has a default value: 10
        pageSize: "10",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 查询押金账单支付流水 GET /api/v1/finance/deposits/${param0}/payment-records */
export async function FinanceDepositControllerListPaymentRecordsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceDepositControllerListPaymentRecordsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputPaymentRecordDtoArray>(
    `/api/v1/finance/deposits/${param0}/payment-records`,
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}

/** 获取财务概览统计 GET /api/v1/finance/overview */
export async function FinanceOverviewControllerGetOverviewV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceOverviewControllerGetOverviewV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceOverviewDto>(
    "/api/v1/finance/overview",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 本商户分账参与方树 GET /api/v1/finance/participants */
export async function FinanceParticipantControllerListTreeV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputSettlementParticipantDtoArray>(
    "/api/v1/finance/participants",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 创建分账参与方 POST /api/v1/finance/participants */
export async function FinanceParticipantControllerCreateV1(
  body: MyApi.CreateMerchantParticipantDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputSettlementParticipantDto>(
    "/api/v1/finance/participants",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除分账参与方 DELETE /api/v1/finance/participants/${param0} */
export async function FinanceParticipantControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceParticipantControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/finance/participants/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新分账参与方 PATCH /api/v1/finance/participants/${param0} */
export async function FinanceParticipantControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceParticipantControllerUpdateV1Params,
  body: MyApi.UpdateSettlementParticipantDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputSettlementParticipantDto>(
    `/api/v1/finance/participants/${param0}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 分页查询收款流水 GET /api/v1/finance/payment-records */
export async function FinancePaymentRecordControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinancePaymentRecordControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDtoArray>(
    "/api/v1/finance/payment-records",
    {
      method: "GET",
      params: {
        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        // pageSize has a default value: 10
        pageSize: "10",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 分页查询退款记录 GET /api/v1/finance/refunds */
export async function FinanceRefundControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceRefundControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDtoArray>(
    "/api/v1/finance/refunds",
    {
      method: "GET",
      params: {
        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        // pageSize has a default value: 10
        pageSize: "10",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 查看本商户清分配置 GET /api/v1/finance/settlement-config */
export async function FinanceSettlementConfigControllerGetV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputMerchantSettlementConfigDto>(
    "/api/v1/finance/settlement-config",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 分页查询结算单 GET /api/v1/finance/settlements */
export async function FinanceSettlementControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceSettlementControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceSettlementDtoArray>(
    "/api/v1/finance/settlements",
    {
      method: "GET",
      params: {
        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        // pageSize has a default value: 10
        pageSize: "10",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 资金结算汇总 GET /api/v1/finance/settlements/summary */
export async function FinanceSettlementControllerSummaryV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputFinanceSettlementSummaryDto>(
    "/api/v1/finance/settlements/summary",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 分页查询提现记录 GET /api/v1/finance/withdrawals */
export async function FinanceWithdrawalControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.FinanceWithdrawalControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceWithdrawalDtoArray>(
    "/api/v1/finance/withdrawals",
    {
      method: "GET",
      params: {
        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        // pageSize has a default value: 10
        pageSize: "10",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 申请提现 POST /api/v1/finance/withdrawals */
export async function FinanceWithdrawalControllerApplyV1(
  body: MyApi.ApplyWithdrawalDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputFinanceWithdrawalDto>(
    "/api/v1/finance/withdrawals",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
